module.exports = __webpack_public_path__ + "img/zh-TW.52582e4d.svg";